(function () {
  if (typeof Swiper === 'undefined') return;


  function initProductGalleries() {
    document.querySelectorAll('.swiper').forEach((galleryEl) => {
      if (galleryEl.dataset.initialized === 'true') return;
      galleryEl.dataset.initialized = 'true';

      const wrapper = galleryEl.closest('.product, .section, body');
      const thumbs = Array.from(wrapper.querySelectorAll('.thumb-item'));
      const thumbsGrid = wrapper.querySelector('.product-thumbs-grid');
      const toggleBtn = wrapper.querySelector('.thumbs-show-more');
      if (!thumbs.length) return;

      function scrollGalleryIntoView(el) {
        if (window.innerWidth < 768) return;
        const rect = el.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        window.scrollTo({
          top: rect.top + scrollTop - 80,
          behavior: 'smooth',
        });
      }

      function scrollThumbIntoView(index) {
        if (window.innerWidth >= 768) return;
        if (!thumbsGrid || !thumbs[index]) return;

        const thumb = thumbs[index];
        const containerRect = thumbsGrid.getBoundingClientRect();
        const thumbRect = thumb.getBoundingClientRect();

        thumbsGrid.scrollBy({
          left:
            thumbRect.left -
            containerRect.left -
            containerRect.width / 2 +
            thumbRect.width / 2,
          behavior: 'smooth',
        });
      }

      const mainSwiper = new Swiper(galleryEl, {
        navigation: {
          nextEl: wrapper.querySelector('.carousel-button-next'),
          prevEl: wrapper.querySelector('.carousel-button-prev'),
        },
        on: {
          slideChange(swiper) {
            const index = swiper.activeIndex;            
            if (window.innerWidth < 768) {
            setActiveThumb(index);
            scrollThumbIntoView(index);
            }                        
          },
        },
      });

      let lastActiveIndex = 0;

      function setActiveThumb(index) {
        if (index === lastActiveIndex) return;
        thumbs[lastActiveIndex]?.classList.remove('thumb-item--active');
        thumbs[index]?.classList.add('thumb-item--active');
        lastActiveIndex = index;
      }

      thumbs[0]?.classList.add('thumb-item--active');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (window.innerWidth >= 768) {
            thumb.querySelector('.thumb-zoom-btn')?.click();
            return;
          }

          const index = Number(thumb.dataset.index);
          if (isNaN(index)) return;

          mainSwiper.slideTo(index, 0);
        });
      });

      if (toggleBtn && thumbsGrid && thumbs.length > 4) {
        thumbsGrid.dataset.collapsed = 'true';
        toggleBtn.textContent = 'SHOW MORE';

        toggleBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          const collapsed = thumbsGrid.dataset.collapsed === 'true';
          thumbsGrid.dataset.collapsed = collapsed ? 'false' : 'true';
          toggleBtn.textContent = collapsed ? 'SHOW LESS' : 'SHOW MORE';

          if (!collapsed && window.innerWidth >= 768) {
            scrollGalleryIntoView(toggleBtn);
          }
        });
      }
    });
  }

  function initImageClickToOpenModal() {
     if (window.innerWidth < 1024) return;
    document
      .querySelectorAll('#ProductGallery .main-image-click')
      .forEach((img) => {
        if (img.dataset.modalBound) return;
        img.dataset.modalBound = 'true';

        img.addEventListener('click', (e) => {
          img
            .closest('.product, body')
            ?.querySelector(
              'modal-opener[data-modal^="#ProductModal"] button'
            )
            ?.click();
        });
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductGalleries();
    initImageClickToOpenModal();
  });

  document.addEventListener('shopify:section:load', () => {
    initProductGalleries();
    initImageClickToOpenModal();
  });
})();
